import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-pg-loading',
    templateUrl: './pg-loading.component.html',
    styleUrls: ['./pg-loading.component.scss'],
    standalone: false
})

export class PgLoadingComponent implements OnInit {
    @Input() progressRatio:number = null;
    @Input() progressCurrent:number = null;
    @Input() progressTotal:number = null;
    @Input() hasError:boolean;
    @Input() isLarge:boolean;
    @Input() isSmall:boolean;
    @Input() isOverlay:boolean;
    @Input() isFullscreen:boolean;

    hasProgressBar() {
        return this.progressRatio != null || (this.progressCurrent != null && this.progressTotal != null && this.progressTotal != 0)
    }

    getProgressRatio() {
        if(this.progressRatio != null) {
            return this.progressRatio;
        }
        else if(this.progressCurrent != null && this.progressTotal != null && this.progressTotal != 0) {
            return this.progressCurrent / this.progressTotal;
        }
    }

    getProgressPercent() {
        return Math.round(this.getProgressRatio() * 100)
    }

    constructor() { }

    ngOnInit() {
    }
}
